import {MdLocationPin} from 'react-icons/md';

type Props = {
  place?: string;
};

export const PlaceText: React.FC<Props> = ({place = ''}) => {
  if (!place) return null;

  return (
    <div className="flex items-center text-black-2 gap-4 text-sm">
      <MdLocationPin size={12} />
      <span>{place}</span>
    </div>
  );
};
